import React, { Component } from 'react';

class StoriesSkeleton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <React.Fragment>
        <section className="common-image-text image-text global-stories-image-text">
          <div className="container">
            <div className="flex flex-wrap -mx-4 skeleton">
              <div className="w-full xl:w-1/2 px-4 left-container">
                <div className="text-content-wrapper">
                  <div className="upper-content">
                    <div className="article-title skeleton-shine"></div>
                  </div>
                  <div className="lower-content mt-6 xl:mt-0">
                    <div className="article-description">
                      <div className="skeleton-shine mb-1"></div>
                      <div className="skeleton-shine mb-1"></div>
                      <div className="skeleton-shine mb-10"></div>

                      <div className="skeleton-shine mb-1"></div>
                      <div className="skeleton-shine mb-1"></div>
                      <div className="skeleton-shine mb-1"></div>
                      <div className="skeleton-shine mb-1"></div>
                      <div className="skeleton-shine"></div>
                    </div>
                    <div className="link skeleton-shine"></div>
                  </div>
                </div>
              </div>

              <div className="w-full xl:w-1/2 mt-6 xl:mt-0 px-4 right-container">
                <div className="image-wrapper skeleton-shine"></div>
              </div>
            </div>
          </div>
        </section>
        <section className="global-stories-results">
          <div className="container">
            <div className="articles-grid">
              <div className="article-wrapper skeleton">
                {
                  Array.from(Array(9).keys()).map((i) => {
                    return (
                      <div className="article-item" key={i}>
                        <div className="image-container skeleton-shine"></div>
                        <div className="content-container">
                          <div className="article-category skeleton-shine mb-2"></div>
                          <div className="article-date skeleton-shine mb-5"></div>
                          <div className="article-title skeleton-shine mb-5"></div>
                          <div className="link link-view skeleton-shine"></div>
                        </div>
                      </div>
                    );
                  })
                }
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default StoriesSkeleton;



// WEBPACK FOOTER //
// ./scripts/components/StoriesSkeleton/StoriesSkeleton.js